<section class="content__main">
    <section class="content-main__content">

        <h1>{{titleContentMain}}</h1>

        <p>{{descriptionContentMain}}</p>

        <app-content-about titleH3="Viagens que Inspirarão sua Alma:" paragraph="Embarque conosco em uma jornada que transcende mapas e destinos. Nossas dicas de viagem não são apenas
        itinerários, mas histórias tecidas através de paisagens exuberantes, sons e aromas distintos. Descubra
        lugares pitorescos, culturas fascinantes e aventuras inesquecíveis que ampliarão seus horizontes e deixarão sua alma
        ansiosa por explorar mais."></app-content-about>
        <app-content-about titleH3="Reflexões Profundas sobre a Vida:" paragraph="A vida é um enigma intrigante, e aqui, procuramos decifrá-lo juntos. Compartilhamos pensamentos
        introspectivos
        sobre questões que nos desafiam diariamente. Desde como encontrar o equilíbrio entre trabalho e lazer até
        explorar o significado da felicidade, convidamos você a mergulhar em discussões que irão estimular sua mente
        e
        tocar seu coração."></app-content-about>
        <app-content-about titleH3="Desvendando a Tapeçaria Tecnológica:" paragraph="Em um mundo movido pela tecnologia, mantenha-se atualizado com nossos insights envolventes. Analisamos as
        últimas tendências tecnológicas, examinamos os impactos das inovações em nossa sociedade e discutimos como a
        tecnologia está moldando nosso futuro. Seja você um entusiasta da tecnologia ou alguém que deseja entender
        seu
        impacto, encontrará conteúdo esclarecedor e acessível."></app-content-about>
        <app-content-about titleH3="Cultura em Todas as Suas Cores:" paragraph="     A cultura é a teia que conecta a humanidade, e aqui celebramos sua diversidade. Explore conosco as artes,
            tradições, gastronomia e costumes de diferentes partes do mundo. Do folclore às últimas tendências
            culturais,
            convidamos você a se perder nas nuances que tornam cada sociedade única e vibrante.
       "></app-content-about>

       <p>{{footerContentMain}}</p>

    </section>
</section>